import { GlFilteredSearchSuggestion } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import API from '../../../../api.js?vue3';
import { createAlert } from '../../../../alert.js?vue3';
import { __ } from '~/locale';
import { camelizeKeys } from '~/lib/utils/object_utils';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import BaseToken from './base_token.vue?vue3';
export default {
    name: 'NamespaceToken',
    components: {
        BaseToken,
        GlFilteredSearchSuggestion
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        active: {
            type: Boolean,
            required: true
        }
    },
    data () {
        return {
            namespaces: [],
            loading: true
        };
    },
    methods: {
        getActiveNamespace (namespaces, selected) {
            return namespaces.find((namespace)=>namespace.fullPath === selected);
        },
        setNamespaces (namespaces) {
            this.namespaces = namespaces.map(camelizeKeys);
        },
        fetchNamespaces (searchTerm) {
            this.loading = true;
            API.namespaces(searchTerm, {
                full_path_search: true
            }, this.setNamespaces).catch(()=>createAlert({
                    message: __('There was a problem fetching namespaces.')
                })).finally(()=>{
                this.loading = false;
            });
        }
    }
};
